/**
 * Page Transitions — Smooth fade between pages
 * Intercepts internal link clicks, fades out content, then navigates.
 */
(function () {
  'use strict';

  var TRANSITION_DURATION = 250;
  var wrapper = document.querySelector('.page-transition-wrapper');
  var bar = document.querySelector('.page-transition-bar');

  if (!wrapper) return;

  function shouldIntercept(anchor) {
    // Must be same origin
    if (anchor.hostname !== window.location.hostname) return false;
    // Skip anchor links
    if (anchor.getAttribute('href').charAt(0) === '#') return false;
    // Skip target=_blank
    if (anchor.target === '_blank') return false;
    // Skip Shopify admin links
    if (anchor.pathname.indexOf('/admin') === 0) return false;
    // Skip cart action links
    if (anchor.pathname.indexOf('/cart') === 0) return false;
    // Skip checkout links
    if (anchor.pathname.indexOf('/checkout') === 0) return false;
    // Skip links with download attribute
    if (anchor.hasAttribute('download')) return false;
    // Skip javascript: links
    if (anchor.protocol === 'javascript:') return false;
    // Skip links with data-no-transition
    if (anchor.hasAttribute('data-no-transition')) return false;
    return true;
  }

  // Intercept link clicks
  document.addEventListener('click', function (e) {
    // Skip clicks on buttons, inputs, or cart-related elements inside links
    var clickTarget = e.target.closest('button, [data-quick-add], [data-quantity-minus], [data-quantity-plus], [data-add-to-cart], [data-cart-toggle], [data-search-toggle], [data-mobile-menu-toggle]');
    if (clickTarget) return;

    var anchor = e.target.closest('a');
    if (!anchor) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return; // Allow modifier clicks
    if (e.defaultPrevented) return;
    if (!shouldIntercept(anchor)) return;

    e.preventDefault();
    var href = anchor.href;

    // Start transition
    wrapper.classList.add('is-transitioning');
    if (bar) {
      bar.classList.add('is-active');
    }

    // Navigate after fade-out
    setTimeout(function () {
      window.location = href;
    }, TRANSITION_DURATION);
  });

  // Handle back/forward button (bfcache)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      // Page was restored from bfcache — remove transition state
      wrapper.classList.remove('is-transitioning');
      if (bar) {
        bar.classList.remove('is-active');
        bar.classList.remove('is-done');
        bar.classList.remove('is-hidden');
      }
    }
  });

  // Mark bar as done when page is about to unload
  window.addEventListener('beforeunload', function () {
    if (bar) {
      bar.classList.add('is-done');
      setTimeout(function () {
        bar.classList.add('is-hidden');
      }, 150);
    }
  });
})();
